var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.7,2.9C185.3-.1,242.8,59.5,236.6,130c-5.9,67.8-67.9,116.7-135.5,105.7S-8.3,161.4,5.3,95.9C16.2,44,61.5,5.2,114.7,2.9ZM67,72.1v106.2h41.4c13.6-.4,28-5,35.1-17.4,7-12.3,5.4-30.9-6.1-39.9s-4.5-3-6.8-4.1c1.5-1.8,3.5-3,5-4.7,8.7-9.3,10-24.9,3.3-35.7s-19.2-14.4-31-14.8c-9.5.5-19.7-.7-29.1,0s-11.2,4.7-11.9,10.4ZM170.1,149.3c-5.1.7-10.1,5.2-11.5,10.1-4.1,13.8,12,24.8,23.2,15.5s3.1-27.6-11.7-25.6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.5,158.4v-25.8c0-.4.9-2.5,1.2-2.9,1.1-1.7,3-2.6,5-2.7,4.2-.3,10.9-.3,15.1,0,6.9.5,12.4,5.3,13.5,12.1,1.4,8.2-1.8,16.4-10.3,18.7s-2.3.6-2.5.6h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,108.7v-22c0,0,.5-1.5.6-1.8.5-1.3,1.3-2.3,2.5-3,2.8-1.5,10.9-1.3,14.3-1.1,6.2.4,11,2.8,12.8,9.1s-.5,15.7-7.9,18.1-2.2.7-2.5.7h-19.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/bookingIcon.31939664d899d4985ea4f127df30f3ce.svg";
export { ForwardRef as ReactComponent };